<template>
    <div class="page-wrapper">
        <header-aotai/>
          <router-view :key="$route.fullPath" id="main"/>
        <footer-aotai class="site-footer"/>

        <!-- 
          touchstart：当手指触摸屏幕时触发；即使已经有一个手指放在了屏幕上也会触发。
          touchmove：当手指在屏幕上滑动时连续地触发。在这个世界发生期间，调用preventDefault()可以阻止滚动。
          touchend：当手指在屏幕上移开时触发。
          touchcancel：当系统停止跟踪触摸时触发。关于此事件的确切触发时间，文档中没有明确说明。
         -->
        <div 
            class="mobile_div"  
            @touchmove.stop.prevent="addmove" 
            @touchstart="touchstart()" 
            @touchcancel="addScale=100" 
            @touchend="touchEnd()" 
            :style="{'transform': `scale(${addScale}%, ${addScale}%)`, 'left':addLeft,'top':addTop, 'z-index': 1000}"
        >
            <div v-if="currentLocale == 'zh_CN'" class="mobile_div_title" @click="handleDrawer">
                <span>
                  <!-- 申请体验 -->
                  {{ $t('seek.seek_btn') }}
                </span>
                
            </div>
            <div v-if="currentLocale == 'en_US'" class="mobile_div_icon" @click="handleDrawer">
                 <span>
                  <i class="el-icon-message" style="font-size: 22px;"></i>
                </span>
            </div>
        </div>
        
        <mb-drawer v-if="isDrawer" @close="handleClose"/>    
    </div>
  </template>
  <script>
  import HeaderAotai from './header.vue'
  import FooterAotai from './footer.vue'
  import MbDrawer from '@/components/mbDrawer.vue'
  export default {
    components: {
      HeaderAotai,
      FooterAotai,
      MbDrawer
    },
    data() {
			return {
        isDrawer: false,
				// 加号按钮大小变形，按下拖动时变大，松开变小
				addScale:100,
				//添加按钮位于页面顶部多少距离
				addTop:'0rpx',
				//添加按钮位于页面左边多少距离
				addLeft:'0rpx',
				// 按钮一半大小，做个偏移，让按钮在中心
				buttonSize:0,
				// 按钮可移动边距
				moveLeft:0,
				moveRight:0,
				moveTop:0,
				moveBottom:0,
			}
		},

    computed: {
      // 只读：自动响应 $i18n.locale 变化
      currentLocale() {
          return this.$i18n.locale;
      },
      
     
  },
    created() {
    },
    mounted() {
			// debugger
      if(this.addTop=='0rpx'||this.addLeft=='0rpx'){
        // 获取手机屏幕宽高，为add按钮设置大小，和初始位置
        // let height = uni.getSystemInfoSync().windowHeight;
        // let width = uni.getSystemInfoSync().windowWidth;
        var width = window.innerWidth;
        var height = window.innerHeight;
        // 设置边距
        //注意，这个是按钮大小的一半，不要配错了，配错了拖动的就不是按钮中心位置了

        // this.moveLeft = rpx10 + this.buttonSize
        // this.moveTop = rpx10 + this.buttonSize
        // this.moveRight = width - rpx10 - this.buttonSize
        // this.moveBottom = height - rpx10 - this.buttonSize 
        
        this.moveLeft =0
        this.moveTop = 0
        this.moveRight = width - 44
        this.moveBottom = height - 44
        
        
        // // 配置add按钮初是位置
        // this.addLeft=`${width - (width/4) - this.buttonSize}px`
        // this.addTop=`${height - (height/4) - this.buttonSize}px`
      }
    },
    methods: {

           // 申请体验
      handleDrawer() {
        this.isDrawer = true
      },
      handleClose() {
        this.isDrawer = false
      },


      // 加号按钮拖动
      addmove(e){
        // this.handleMoving()
        if(e.touches.length>0){
          // x轴移动限制
          let x = e.touches[0].clientX<this.moveLeft?this.moveLeft:e.touches[0].clientX>this.moveRight?this.moveRight:e.touches[0].clientX
          // y轴移动限制
          let y =  e.touches[0].clientY<this.moveTop ? this.moveTop : e.touches[0].clientY>this.moveBottom? this.moveBottom : e.touches[0].clientY
          this.addLeft=`${x }px`
          this.addTop=`${y}px`

        }
        
      },
      // handleMoving () {
      //   // 禁止body滚动
      //   document.body.style.overflow = 'hidden'
      //   // 禁止body文本选中
      //   document.body.style.userSelect = 'none'
      // },
      touchstart() {
        this.addScale=120
      },
      touchEnd () {
        this.addScale=100
        // document.body.style.overflow = 'auto'
        // document.body.style.userSelect = 'auto'
      },

    }
  }
  </script>
  <style lang="less" scoped>
    .main-header--one {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 500;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      padding: 0 60px;
      transition: all 0.36s;
  }

  .main-header .main-header--one {
    position: fixed;
  }
  .app-wrapper {
      width: 100%;
  
   
  
      -ms-overflow-style: none; /* IE 10+ */
      // 主体区域
      /*.main-container {*/
      /*    position: relative;*/
      /*    margin-left: 200px;*/
      /*    min-height: 100%;*/
      /*    padding-top: 80px;*/
      /*    background-color: #f1f2f7;*/
      /*}*/
  }
  
  // banner图
  
  .page-header {
      overflow: hidden;
      position: relative;
      /* position: relative;
      display: block; */
      padding: 150px 0 150px;
      /* background-color: var(--notech-black); */
      z-index: 1;
  }
  
  .page-header__inner {
      text-align: left;
  }
   .page-header__inner h1{
      font-size: var(--font-size-30);
      color: var(--notech-white);
      font-weight: 700;
      line-height: 50px;
      margin-bottom: 7px;
   }
   .page-header__inner h3{
      font-size: var(--font-size-20);
      margin-top: 13px;
      line-height: 1.75;
      color: var(--notech-white);
   }
  
   .page-header__breul {
      position: absolute;
      bottom: 20px;
   }
   .mobile_div {
    position: fixed;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 0.1em 0.6em 0px, rgba(0, 0, 0, 0.09) 0px 0.2em 3.2em 0px;
    background: var(--notech-base);
    color: #fff;
    height: 44px;
    width: 44px;
    border-radius: 50%;
    font-size: 10px;
    margin-left: 0px;
    margin-top: 0px;
    z-index: 99;
    right: 0;
    bottom: 249.2px;
  }
  .mobile_div_title{
    float: left;
    color: rgb(255, 255, 255);
    word-wrap: break-word;
    text-align: center;
    display: block;
    width: 2.17em;
    height: 2.67em;
    font-size: 1.2em;
    line-height: 1.33em;
    margin: 0.5em 0.75em;
  }
  .mobile_div_icon{
    color: rgb(255, 255, 255);
    width: 100%;
    height: 100%;
    // display: flex;
    text-align: center;
    line-height: 48px;
  }
  </style>
  